export default "__VITE_ASSET__74IldoCv__"